import React, { useState, useEffect } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { useNavigate } from "react-router-dom";
import { DeleteModalCategory } from "../../../components"
import Dots from "../../../assets/icon/NewsIcons/MainAdmin/NewsDot3"
import Edit from "../../../assets/icon/NewsIcons/MainAdmin/NewsOrangePen"
import Delete from "../../../assets/icon/NewsIcons/MainAdmin/NewsDeleteBlack"
import { ReactComponent as Right } from "../../../assets/icon/right.svg";
import { ReactComponent as Left } from "../../../assets/icon/left.svg";

const MainAdminNewsCategoryTable = ({ data, reCheck, setRecheck, setAllValues, setEdit,count, page, setPage, row, setRow, tags }) => {


  let navigate = useNavigate()
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [id, setId] = useState();
  return (
    <div className="rounded-[15px] pt-[15px] px-[15px] pb-[120px] border-borderGray border-2 w-full">
      <table className="w-full">
        <tr className="h-[60px] w-full bg-lightBlue2">
          {tags == true ?
          <>
          <th className="rounded-r-[15px] text-right pr-[17px] text-[15px] font-IRANYekanBold text-mainColor2">ردیف</th>
          <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">نام برچسب </th>
          {/* <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">نامک</th> */}
          {/* <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">توضیح</th>
          <th className="text-[15px] text-center font-IRANYekanBold text-mainColor2">رنگ انتخاب شده</th> */}
          {/* <th className="text-[15px] text-center font-IRANYekanBold text-mainColor2">تعداد</th> */}
          <th className="rounded-l-[15px] text-center pl-[17px] text-[15px] font-IRANYekanBold text-mainColor2">عملیات</th>
          </>
          :
          <>
          <th className="rounded-r-[15px] text-right pr-[17px] text-[15px] font-IRANYekanBold text-mainColor2">ردیف</th>
          <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">نام دسته بندی</th>
          {/* <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">نامک</th> */}
          <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">توضیح</th>
          <th className="text-[15px] text-center font-IRANYekanBold text-mainColor2">رنگ انتخاب شده</th>
          {/* <th className="text-[15px] text-center font-IRANYekanBold text-mainColor2">تعداد</th> */}
          <th className="rounded-l-[15px] text-center pl-[17px] text-[15px] font-IRANYekanBold text-mainColor2">عملیات</th>
          </>
          }
        </tr>
        {tags == true ?
        <>
        {
          data?.map((item, index) => {
            return (
             
              <tr className="h-[56px] w-full border-b-2 border-borderGray">
                <th className="text-[14px] text-right pr-[17px] font-IRANYekanNormal">{ index + 1 + ((page - 1) * row)}</th>
                <th className="text-[14px] text-right font-IRANYekanNormal">{item?.tag}</th>
                {/* <th className="text-[14px] text-right font-IRANYekanNormal">سیاسی</th> */}
                {/* <th className="text-[8px] w-[160px] leading-5 text-right font-IRANYekanNormal">{item?.descreption}</th>
                <th className="text-[15px] text-right font-IRANYekanBold">
                  <div className="w-full flex justify-center">

                    <div style={{backgroundColor:item?.color}} className={`w-[30px] h-[30px] rounded-full `}></div></div></th> */}
                {/* <th className="text-[15px] text-center font-IRANYekanBold">12</th> */}
                <th><div className="flex ml-[17px] justify-center items-center">
                  <Menu as="div" className="relative  text-center flex justify-center items-center bg-borderGray rounded-full h-[30px] w-[30px]">
                    <div>
                      <MenuButton className="h-[40px] flex justify-center items-center   w-full rounded-md px-3 py-2">
                        <Dots />
                      </MenuButton>
                    </div>

                    <MenuItems
                      transition
                      className="absolute top-6 left-[1px] z-10 mt-2 shadow-search-shadow w-[89px] origin-top-right rounded-md bg-white  ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                    >
                      <div className="py-1 flex flex-col items-start shadow-search-shadow">
                        <MenuItem>
                          <button
                            onClick={() => {
                              console.log(item);
                              setAllValues({
                                CategoryId:item?.tagId,
                                CategoryName: item?.tag,
                                Edit:true
                              }); 
                            }
                              // navigate("/mainAdmin/newsCategory/edit")
                            }
                            className="flex justify-start items-center border-b-[2px] w-full border-borderGray px-2 pb-1 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                          >
                            <div><Edit /></div>
                            <p className="font-IRANYekanNormal text-[10px] text-Orange2 mr-[5px] " >ویرایش</p>
                          </button>
                        </MenuItem>
                        <MenuItem>
                          <button
                            onClick={() => { setShowDeleteModal(true); setId(item?.tagId) }}
                            className="flex justify-start items-center w-full px-2 pt-1 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                          >
                            <div><Delete /></div>
                            <p className="font-IRANYekanNormal text-[10px] mr-[5px]" >حذف</p>
                          </button>
                        </MenuItem>
                      
                        {/* <form action="#" method="POST">
            
          </form> */}
                      </div>
                    </MenuItems>


                  </Menu>
                </div></th>
              </tr>
            )
          })
        }
        </>
        :
        <>
        {
          data?.map((item, index) => {
            return (
             
              <tr className="h-[56px] w-full border-b-2 border-borderGray">
                <th className="text-[14px] text-right pr-[17px] font-IRANYekanNormal">{ index + 1 + ((page - 1) * row)}</th>
                <th className="text-[14px] text-right font-IRANYekanNormal">{item?.categoryName}</th>
                {/* <th className="text-[14px] text-right font-IRANYekanNormal">سیاسی</th> */}
                <th className="text-[8px] w-[160px] leading-5 text-right font-IRANYekanNormal">{item?.descreption}</th>
                <th className="text-[15px] text-right font-IRANYekanBold">
                  <div className="w-full flex justify-center">

                    <div style={{backgroundColor:item?.color}} className={`w-[30px] h-[30px] rounded-full `}></div></div></th>
                {/* <th className="text-[15px] text-center font-IRANYekanBold">12</th> */}
                <th><div className="flex ml-[17px] justify-center items-center">
                  <Menu as="div" className="relative  text-center flex justify-center items-center bg-borderGray rounded-full h-[30px] w-[30px]">
                    <div>
                      <MenuButton className="h-[40px] flex justify-center items-center   w-full rounded-md px-3 py-2">
                        <Dots />
                      </MenuButton>
                    </div>

                    <MenuItems
                      transition
                      className="absolute top-6 left-[1px] z-10 mt-2 shadow-search-shadow w-[89px] origin-top-right rounded-md bg-white  ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                    >
                      <div className="py-1 flex flex-col items-start shadow-search-shadow">
                        <MenuItem>
                          <button
                            onClick={() => {
                              console.log(item);
                              setAllValues({
                                CategoryId:item?.categoryId,
                                CategoryName: item.categoryName,
                                Color: item?.color,
                                Descreption: item.descreption,
                                Edit:true
                              }); 
                            }
                              // navigate("/mainAdmin/newsCategory/edit")
                            }
                            className="flex justify-start items-center border-b-[2px] w-full border-borderGray px-2 pb-1 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                          >
                            <div><Edit /></div>
                            <p className="font-IRANYekanNormal text-[10px] text-Orange2 mr-[5px] " >ویرایش</p>
                          </button>
                        </MenuItem>
                        <MenuItem>
                          <button
                            onClick={() => { setShowDeleteModal(true); setId(item?.categoryId) }}
                            className="flex justify-start items-center w-full px-2 pt-1 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                          >
                            <div><Delete /></div>
                            <p className="font-IRANYekanNormal text-[10px] mr-[5px]" >حذف</p>
                          </button>
                        </MenuItem>

                        {/* <form action="#" method="POST">
            
          </form> */}
                      </div>
                    </MenuItems>


                  </Menu>
                </div></th>
              </tr>
            )
          })
        }
        </>
      }


      </table>
      <div className="  w-full py-3 px-3">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                            <p className="text-sm text-right px-4 font-IRANYekanMedium">
                                تعداد ردیف در هر صفحه :
                            </p>
                            <div className="flex flex-col w-[80px] ml-20 font-IRANYekanMedium">
                                <div class=" ">

                                    <select
                                        name="rowNumber"
                                        id="rowNumber"
                                        onChange={(e) => { setRow(e.target.value); setPage(1) }}
                                        className="   text-right  bg-white border border-gray-300 text-gray-900 text-sm rounded-md  focus:ring-mainColor focus:border-mainColor block w-full px-2 py-1">
                                        <option value="5" className=" ">۵ </option>
                                        <option value="10" selected className=" ">۱۰</option>
                                        <option value="25" className=" ">۲۵</option>


                                    </select>
                                    {/* <input
                              type="text"
                              id="input-group-1"
                              disabled="true"
                              class="pr-9   text-right right-6 bg-white border border-gray-300 text-gray-900 text-sm rounded-md  focus:ring-mainColor focus:border-mainColor block w-full pl-10 p-2.5  "
                              placeholder="آرمان"/> */}
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center font-IRANYekanMedium">
                            
                            <p className="text-sm text-right pr-4 mx-2">
                                {((page - 1) * row) + 1}-{count < row * page ? count : row * page} از {count}
                            </p>
                            <div className="flex mr-2">
                                <button onClick={() => setPage(page + 1)} disabled={count < row * page ? true : false} className="mx-2">
                                    <Right />
                                </button>
                                <button onClick={() => setPage(page - 1)} disabled={page == 1 ? true : false} className="mx-2">
                                    <Left />
                                </button>
                            </div>
                        </div>
                    </div>

                </div>


      {showDeleteModal ?
        <DeleteModalCategory title={tags==true?'حذف برچسب':'حذف دسته بندی'}
         buttonName={'حذف'} 
         tags={tags}
         id={id} setRecheck={setRecheck}
          reCheck={reCheck}
          text={'آیا از حذف مورد انتخاب شده اطمینان دارید ؟'} 
          setShowModal={setShowDeleteModal} /> : null}
    </div>
  )
}

export default MainAdminNewsCategoryTable;